import { db } from "@/firebaseApp"
import { getDoc, setDoc, addDoc, updateDoc, deleteDoc, getDocs } from "firebase/firestore"
import { collection, doc } from "firebase/firestore"
import { query, where, orderBy, startAfter, limit } from "firebase/firestore"

const DEFAULT_PAGE_SIZE = 20

// READ - Get documents
export const getDocuments = async (coll) => {
  const docQuery = await getDocs(collection(db, coll))
  const docList = docQuery.docs.map((doc) => doc.data())
  return docList
}

// READ - Get subcollection
export const getSubcollections = async (coll, setId, subcoll) => {
  const subcollections = await getDocs(collection(db, coll, setId, subcoll))
  const docList = subcollections.docs.map((doc) => doc.data())
  return docList
  /*
  subcollection.forEach((doc) => {
      console.log(doc.data())
  })
  */
}

// CREATE - Insert a document
export const createDocument = async (coll, document) => {
  const docRef = collection(db, coll, document.id)
  await setDoc(docRef, document)
}

// CREATE - Insert a document
export const addDocument = async (coll, document) => {
  await addDoc(collection(db, coll), document)
}

// UPDATE - Update document by ID
export const updateDocument = async (coll, docId, updatedData) => {
  const docRef = collection(db, coll, docId)
  await updateDoc(docRef, updatedData)
}

// DELETE - Delete a document by ID
export const deleteDocument = async (coll, id) => {
  const docRef = collection(db, coll, id)
  await deleteDoc(docRef)
}

// READ - Get document by REF
export const getDocumentByRef = async (ref) => {
  const docSnap = await getDoc(ref)
  return docSnap.exists() ? docSnap.data() : null
}

// READ - Get document by ID
export const getDocumentById = async (segment, id) => {
  const docSnap = await getDoc(doc(db, segment, id))
  return docSnap.exists() ? docSnap.data() : null
}

/* ------------------- */

// Helper function to convert object list to DocumentReferences
export const objectListToDocumentReferences = async (refObjectList) => {
  const references = Object.values(refObjectList).map((refData) => {
    // Extract the collection and documentId from each object in the array
    return doc(db, refData._key.path.segments[5], refData._key.path.segments[6])  // Create a DocumentReference
  })
  return references
}

// Helper function to convert object to DocumentReference
export const objectToDocumentReference = async (refObject) => {
  return doc(db, refObject._key.path.segments[5], refObject._key.path.segments[6])
}

// Helper function to normalize device ID from various input formats
const normalizeDeviceId = (deviceItem) => {
  if (!deviceItem) return null
  if (typeof deviceItem === "string") return deviceItem
  if (typeof deviceItem === "object") {
    if (deviceItem.id) return deviceItem.id
    // support object reference style: refData._key.path.segments[6]
    const seg = deviceItem?._key?.path?.segments
    if (Array.isArray(seg) && seg.length >= 7) return seg[6]
  }
  return null
}

// Helper: safe nested field read via path like "A.B.C"
const getByPath = (obj, path) => {
  if (!obj || !path) return undefined
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj)
}

/* ------------------- */

// READ - Get a User by UID
export const getUserByUid = async (uid) => {
  const q = query(collection(db, 'users'), where('UID', '==', uid), limit(1))
  const querySnap = await getDocs(q)
  const dcs = querySnap.docs
  return (dcs.length > 0) ? dcs[0].data() : null
}

// READ - Get Devices of Customer
export const getDevicesByList = async (deviceList, pageIndex = 0, pageSize = DEFAULT_PAGE_SIZE) => {
  /*
  let res = []
  await refList.slice(0, DEVICES_PAGE_SIZE).forEach(async element => {
    const docSnap = await getDoc(doc(db, 'devices', element._key.path.segments[6]))
    res.push(docSnap)
  })
  return res
  */

  const allDevices = []
  const devicesPromises = deviceList.slice(pageIndex, pageSize).map(async (deviceItem) => {
    const deviceSnapshot = await getDoc(doc(db, 'devices', deviceItem))
    //const deviceSnapshot = await getDoc(deviceItem)
    if (deviceSnapshot.exists) {
      allDevices.push(deviceSnapshot) // Add the device data
    }
  })
  await Promise.all(devicesPromises)
  return allDevices
}

// READ - Get documents
export const getDevices = async (pageIndex = 0, pageSize = DEFAULT_PAGE_SIZE) => {
  const devicesRef = collection(db, "devices");
  // let q = query(devicesRef, orderBy("createdAt"), limit(pageSize));
  let q = query(devicesRef, limit(pageSize));

  if (pageIndex > 0) {
    const lastVisibleDoc = await getLastVisibleDocument(pageIndex, pageSize);
    q = query(devicesRef, startAfter(), limit(pageSize));
  }

  // Fetch the documents
  const querySnapshot = await getDocs(q);



  const docQuery = await getDocs(collection(db, 'devices'))
  return docQuery.docs
}

// READ - Get device refs by customer doc and its subcustomers
export const getDeviceListOfCustomer = async (customerDoc) => {
  try {
    const allDevices = []

    const customerDevices = customerDoc['Devices'] || [] // Assuming `devices` is an array of DocumentReferences
    const subcustomers = customerDoc['SubCustomers'] || [] // Assuming `subcustomers` is an array of DocumentReferences
    allDevices.push(...customerDevices)

    // Now, handle subcustomers recursively by fetching their devices
    const subcustomerPromises = subcustomers.map(async (subcustomerRef) => {
      const subcustomerSnapshot = await getDoc(subcustomerRef)
      if (subcustomerSnapshot.exists) {
        const subcustomerDevices = await getDeviceListOfCustomer(subcustomerSnapshot.data())
        allDevices.push(...subcustomerDevices) // Add the devices from subcustomer
      }
    })

    // Wait for all subcustomer device fetch operations to complete
    await Promise.all(subcustomerPromises)

    return allDevices

  } catch (error) {
    console.error('Error fetching devices:', error)
    throw error
  }
}

/*
// COUNT - Customers (root + all subcustomers) for the inputed user
export const getCustomerCountByUserUid = async (uid) => {
  const rootCustomer = await getRootCustomerOfUser(uid)
  if (!rootCustomer) return 0

  // recursive count: root counts as 1
  const seen = new Set() // avoid double counting if graph isn’t a strict tree

  const countRecursive = async (customerDocOrData) => {
    // If you store an Id on customer doc data, it can help de-dupe.
    // Otherwise we de-dupe by reference string when available.
    const id =
      customerDocOrData?.id ||
      customerDocOrData?.ID ||
      customerDocOrData?.Uid ||
      customerDocOrData?.UID ||
      null

    if (id) {
      if (seen.has(String(id))) return 0
      seen.add(String(id))
    }

    let count = 1
    const subcustomers = customerDocOrData?.SubCustomers || []

    const subs = subcustomers.map(async (subRef) => {
      const subSnap = await getDoc(subRef)
      if (subSnap.exists()) {
        count += await countRecursive(subSnap.data())
      }
    })

    await Promise.all(subs)
    return count
  }

  return await countRecursive(rootCustomer)
}
*/

// COUNT - Devices with LowFragrance active for the inputed user, returns counts of LowFragrance and LastData active devices
export const getDeviceStats = async (
  deviceList,
  fieldPathLowFragrance = "LowFragrance",
  fieldPathLastData = "LastData"
) => {
  const ids = [...new Set(
    deviceList
      .map(normalizeDeviceId)
      .filter((x) => x && typeof x === "string")
  )]

  let countLowFragrance = 0
  let countLastData = 0

  // Fetch devices in parallel (simple approach, matches your style)
  const promises = ids.map(async (deviceId) => {
    const snap = await getDoc(doc(db, "devices", deviceId))
    if (!snap.exists()) return

    const data = snap.data()
    //console.log("Device ID:", deviceId, "Data:", data)
    const valLowFragrance = getByPath(data, fieldPathLowFragrance)
    const valLastData = getByPath(data, fieldPathLastData)

    // treat truthy as "active"
    if (valLowFragrance === true || valLowFragrance === 1 || valLowFragrance === "1" || valLowFragrance === "true")
      countLowFragrance += 1

    // check lastData (firebase timestamp) above specified date threshold
    if (valLastData) {
      const lastDataDate = valLastData.toDate()
      const now = new Date()
      const diffMs = now - lastDataDate
      const diffHours = diffMs / (1000 * 60 * 60)
      if (diffHours <= 24) {
        // consider device active if last data is within 24 hours
        countLastData += 1
      }
    }
  })

  await Promise.all(promises)
  return { countLowFragrance, countLastData }
}